import {useRouteLoaderData} from "react-router-dom";
import translate from "../../../../translate";
import {Column, ColumnGrid} from "../../ui/spectre/grid";
import React from "react";
import GroupMember from "./groupMember";

export default function GroupMembers() {
    /**
     * @type groupDataType
     */
    const groupData = useRouteLoaderData('group');

    if(!groupData.ownPermissions.SeeMemberList) {
        return <div className={'bg-error p-1'}>{translate('error/groups/no_access')}</div>;
    }

    return <div className={'mt-2'}>
        <ColumnGrid size={'md'}>
            <Column sizes={[4]}><div className={'defaultTableHeader'}>{translate('page/group/members/account')}</div></Column>
            <Column sizes={[4]}><div className={'defaultTableHeader'}>{translate('page/group/members/role')}</div></Column>
            <Column sizes={[2]}><div className={'defaultTableHeader'}>{translate('page/group/members/actions')}</div></Column>

            {
                Object.values(groupData.members)
                    .map(member =>
                        <GroupMember
                            key={member.id}
                            accountName={member.accountName}
                            roleName={member.roleName}
                            canEdit={groupData.ownPermissions.EditMemberPermission}
                            canRemove={groupData.ownPermissions.RemoveMember}
                        />
                    )
            }
        </ColumnGrid>
    </div>
}
